/* FTF : un seul lecteur audio pour tout le site, piloté par tous les boutons [data-audio].
   - Jamais de lecture automatique : le son démarre au clic.
   - Son continu : tant que la musique joue, les liens internes remplacent le contenu de la page
     sans la recharger (le lecteur reste en vie). Son coupé = navigation classique.
   - Pages qui rechargent forcément (paiement, compte, mot de passe) : on mémorise la position,
     le bouton propose « Reprendre ».
   - Sur iPhone, un MP3 hébergé chez Shopify est le plus fiable ; YouTube sert de repli. */
(() => {
  if (window.__ftfAudio) return;
  window.__ftfAudio = true;
  const A = (window.FTF || {}).audio || {};
  const KEY = 'ftf_audio';
  const $$ = (s) => [...document.querySelectorAll(s)];
  if (!A.mp3 && !A.yt) { $$('[data-audio]').forEach((b) => { b.hidden = true; }); return; }

  let saved = {}; try { saved = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch {}
  let on = false, pos = Number(saved.t) || 0, ytReady = false, wantPlay = false, player = null, audio = null;

  const paint = () => $$('[data-audio]').forEach((b) => {
    b.setAttribute('aria-pressed', on);
    if (!b.dataset.off) b.dataset.off = b.textContent.trim();
    b.textContent = on ? (b.dataset.on || '■ Son') : (pos > 0 && saved.on ? '▶ Reprendre' : b.dataset.off);
  });
  const now = () => (audio ? audio.currentTime : (player && ytReady ? player.getCurrentTime() : pos)) || pos;

  // ── Moteur MP3 ──
  const playMp3 = () => {
    if (!audio) { audio = new Audio(A.mp3); audio.loop = true; audio.preload = 'auto'; audio.setAttribute('playsinline', ''); }
    if (audio.paused && audio.currentTime === 0) { try { audio.currentTime = pos > 0 ? pos : (Number(A.start) || 0); } catch {} }
    return audio.play();
  };

  // ── Moteur YouTube, préchargé pour que la lecture parte bien pendant le clic ──
  const startYt = () => {
    player.unMute(); player.setVolume(100);
    if (pos > 0 && player.getCurrentTime() < 1) player.seekTo(pos, true);
    player.playVideo();
  };
  if (!A.mp3) {
    const box = document.createElement('div');
    box.dataset.ftfKeep = '';
    box.setAttribute('aria-hidden', 'true');
    box.style.cssText = 'position:fixed;left:0;bottom:0;width:2px;height:2px;opacity:.01;pointer-events:none;z-index:-1;overflow:hidden';
    const slot = document.createElement('div'); box.append(slot); document.body.append(box);
    window.onYouTubeIframeAPIReady = () => {
      player = new YT.Player(slot, {
        host: 'https://www.youtube-nocookie.com', videoId: A.yt, width: 2, height: 2,
        playerVars: { playsinline: 1, controls: 0, disablekb: 1, rel: 0, loop: 1, playlist: A.yt, start: Number(A.start) || 0 },
        events: {
          onReady: () => { ytReady = true; if (wantPlay) startYt(); },
          onStateChange: (e) => { if (e.data === 1 && !on) { on = true; paint(); } },
        },
      });
    };
    const s = document.createElement('script'); s.src = 'https://www.youtube.com/iframe_api'; s.async = true; document.head.append(s);
  }

  const play = () => {
    on = true; paint();
    if (A.mp3) return playMp3().catch(() => { on = false; paint(); });
    if (ytReady) startYt(); else wantPlay = true;
  };
  const stop = () => {
    pos = now(); on = false; wantPlay = false; saved = { on: false, t: pos, stopped: true };
    if (audio) audio.pause();
    if (player && ytReady) player.pauseVideo();
    paint();
  };
  // Délégation : les boutons des pages chargées ensuite marchent aussi.
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-audio]');
    if (b) { e.preventDefault(); on ? stop() : play(); }
  });
  // Premier toucher n'importe où : lance la musique (sauf si la personne l'a déjà coupée).
  // pointerdown/keydown comptent comme un geste pour le navigateur ; le défilement, non.
  if (A.firstTap && !saved.stopped) {
    const first = (e) => {
      ['pointerdown', 'keydown', 'touchend'].forEach((t) => removeEventListener(t, first, true));
      if (on || e.target.closest?.('[data-audio]')) return;
      play();
    };
    ['pointerdown', 'keydown', 'touchend'].forEach((t) => addEventListener(t, first, true));
  }
  addEventListener('pagehide', () => { try { sessionStorage.setItem(KEY, JSON.stringify({ on, t: on ? now() : pos, stopped: !!saved.stopped && !on })); } catch {} });
  paint();

  // ── Navigation sans rechargement pendant que la musique joue ──
  const HARD = /^\/(checkout|checkouts|account|password|admin|cart\/(add|change|clear)|apps|tools)\b/;
  const THEME_JS = /\/(ftf-shop|ftf-closed|ftf-member)\.js/;
  const canSoft = (a, e) => {
    if (!on || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (!a || a.target === '_blank' || a.hasAttribute('download') || a.dataset.noSoft !== undefined) return false;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin || HARD.test(u.pathname)) return false;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
    return u;
  };
  const swap = async (url, push) => {
    let html;
    try {
      const r = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!r.ok || !(r.headers.get('content-type') || '').includes('text/html') || new URL(r.url).pathname.startsWith('/password')) throw 0;
      html = await r.text();
    } catch { location.href = url; return; }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    document.title = doc.title;
    document.body.className = doc.body.className;
    document.body.style.overflow = '';
    [...document.body.children].forEach((n) => { if (!n.hasAttribute('data-ftf-keep')) n.remove(); });
    const scripts = [...new Set([...doc.body.querySelectorAll('script[src]')].map((n) => n.src).filter((s) => THEME_JS.test(s)))];
    [...doc.body.children].forEach((n) => {
      if (n.tagName === 'SCRIPT') return;
      document.body.insertBefore(document.adoptNode(n), document.body.querySelector('[data-ftf-keep]'));
    });
    // Scripts du thème : relancés pour la nouvelle page (ils se protègent des doublons).
    scripts.forEach((src) => {
      const s = document.createElement('script');
      s.src = src + (src.includes('?') ? '&' : '?') + 'n=' + Date.now();
      document.body.append(s);
    });
    if (push) history.pushState({ ftf: 1 }, '', url);
    const h = new URL(url, location.href).hash;
    if (h && document.querySelector(h)) document.querySelector(h).scrollIntoView(); else scrollTo(0, 0);
    paint();
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    const u = canSoft(a, e);
    if (!u) return;
    e.preventDefault();
    swap(u.href, true);
  });
  addEventListener('popstate', () => { if (on) swap(location.href, false); else location.reload(); });
})();
